import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";

const initialValue = {
    sale_products: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                products_data: action.payload,
            }
        }
        case 'UPDATE_STATUS': {
            let newData = state.products_data.sale_products.map((pro) =>
                action.payload.data.id === pro.id ? action.payload.data : pro
            );
            let newState = {
                sale_products: newData
            }
            return {
                ...state,
                products_data: newState,
            }
        }
        default: {
            return state
        }
    }
}

const SaleProductsContext = createContext({
    products_data: initialValue,
    getSaleProductsData: () => {},
    changeProductStatus: () => {},
    make_featured: () => {},
    changeProductDelivery: () => {},
})

export const SaleProductsProvider = ({settings, children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)

    const getSaleProductsData = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/sale_products', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }


    const changeProductDelivery = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_delivery/${product_id}/${status}`, options);

            if(res.status === 200) {
                dispatch({
                    type: 'UPDATE_STATUS',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    const changeProductStatus = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_status/${product_id}/${status}`, options);

            if(res.status === 200) {
                dispatch({
                    type: 'UPDATE_STATUS',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    const make_featured = async (product_id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/make_featured/${product_id}`, options);

            if(res.status === 200) {
                dispatch({
                    type: 'MAKE_FEATURED',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getSaleProductsData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.products_data === undefined) {
        return <MatxLoading />
    }

    return (
        <SaleProductsContext.Provider
            value={{
                products_data: state.products_data,
                getSaleProductsData,
                changeProductStatus,
                changeProductDelivery,
                make_featured,
            }}
        >
            {children}
        </SaleProductsContext.Provider>
    )
}

export default SaleProductsContext
